<template>
  <div id="app">
    <Navigation />
    <Intro />
<!--    <Notification />-->
    <Menu />
    <About />
    <!-- <Reviews /> -->
    <Delivery />
    <Contact />
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import Intro from '@/components/Intro'
import Menu from '@/components/Menu'
import About from '@/components/About'
import Delivery from '@/components/Delivery'
import Contact from '@/components/Contact'
// import Reviews from '@/components/Reviews'
// import Notification from '@/components/Notification '

export default {
  components : {
    // Notification,
    Navigation,
    Intro,
    Menu,
    About,
    // Reviews,
    Delivery,
    Contact
  },
}
</script>

<style lang="scss">
  @import '@/assets/sass/app.scss';
  body {
    padding-top: 5rem;
    margin: 0;
    width: 100%;
    background: #FFFDE7;
    overflow-x: hidden;
  }
  #app {
    font-family: $font-stack;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $font-color;
    position: relative;
  }

@media screen and (max-width: 600px) {
  body{
    background-color: rgb(255, 254, 245);
  }
}
</style>

